export default __webpack_public_path__ + "static/media/multiasset-banner-mob.7b127dad.jpg";